import { Currency, CurrencySelect, DateInputLocalized } from '@components'

import { FormItemsGroup, Input, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import type { EditManualBankAccountFormApi } from '../../hooks/useEditManualBankAccountForm'

interface EditManualBankAccountFormBodyProps {
  form: EditManualBankAccountFormApi
}

export const EditManualBankAccountFormBody = ({
  form: { Form, FormItem, subHeaderTKey },
}: EditManualBankAccountFormBodyProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Form>
      <FormItemsGroup rowSpacing={Spacing.S16}>
        {subHeaderTKey && (
          <Text variant="bodyMD" colorVariant="placeholder">
            {t(subHeaderTKey)}
          </Text>
        )}
        <FormItemsGroup columnSpacing={Spacing.S16} itemsInRow={2} itemsTemplate={['75%', '25%']}>
          <FormItem
            name="accountName"
            label={t('bank.account.modal.account_name')}
            render={({ field: { value, onChange, ...rest } }) => (
              <Input
                {...rest}
                placeholder={t('bank.account.modal.account_name.placeholder')}
                value={value}
                onChange={onChange}
              />
            )}
          />
          <FormItem
            name="currencyId"
            label={t('bank.account.modal.currency')}
            render={({ field: { value, onChange, ...rest } }) => (
              <CurrencySelect
                {...rest}
                dropdownSize="fitTrigger"
                onSelect={(_id?: string, value?: Currency) => onChange(value?.id)}
                selectedId={value}
              />
            )}
          />
          <FormItem
            name="reconciliationStartDate"
            label={t('bank.account.modal.reconciliation_start_date')}
            render={({ field }) => <DateInputLocalized allowClear {...field} />}
          />
        </FormItemsGroup>
        <FormItem
          name="description"
          label={t('bank.account.modal.description')}
          render={({ field: { value, onChange, ...rest } }) => (
            <Input
              {...rest}
              required
              type="textarea"
              placeholder={t('bank.account.modal.description.placeholder')}
              value={value}
              onChange={onChange}
            />
          )}
        />
      </FormItemsGroup>
    </Form>
  )
}
